export interface IValidation {
    subject: boolean,
    message: boolean,
    centers: boolean,
    positions: boolean,
    receiveEmailOption: boolean,
    calendarInvite: boolean
}
